import { config } from "../core/config.js";
import { lang, activeList, g_listOrigin, setListOrigin, currentDataset, setCurrentDataset as setGlobalCurrentDataset } from "../core/variables-global.js";
import { simpleSearchRadioLabels } from "../core/l10n.js";
import helpers from "../utils/helpers.js";
import UIHelper from "../utils/UIHelper.js";

let initListPicker = () => {
  // Variables d'état
  let selectedDate = null;
  let selectedRadioValue = null;
  let enterKeyUsed = false;
  let fileListJson = null;

  // Sélecteurs DOM
  const app = document.querySelector(".js-recherche-thermopompes");
  const step1 = app.querySelector(".js-step-1");
  const step2 = app.querySelector(".js-step-2");
  const dateInputs = document.querySelectorAll(".js-date-picker");
  const radioButtons = document.querySelectorAll(".js-list-radio");
  const submitButton = document.querySelector(".js-button-select-list");
  const restartButton = document.querySelector(".js-restart-list-selection");
  const radioButttonES = document.querySelectorAll(".js-radio-energystar");
  const numberTypeText = app.querySelector('.js-text-number');


  // Chemins et configuration
  const folderListPath = config.filesListPath.data;
  const listName = config.filesListPath.listFiles;

  document.querySelector(".js-bloc-list").style.display = "none";

  // Afficher le chargement immédiatement dès l'initialisation
  showLoadingStep1(true);

  // Initialiser les écouteurs d'événements immédiatement
  initEventListeners();

  // Désactiver le bouton de soumission par défaut
  updateSubmitButtonState();




  // Charger les données en arrière-plan
  // Place la tache à la fin de la queue pour ne pas bloquer l'UI
  setTimeout(() => {
   loadListClientele();
  }, 0);

  // Charge les données initiales et active le formulaire quand c'est prêt
  const loadListClientele = () => {
    // Simuler un temps de chargement minimum pour éviter un flash
    const minLoadTime = 2000; //2000 créer un retar d'affichage
    const startTime = Date.now();

    getListFile().then(data => {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minLoadTime - elapsedTime);

      setTimeout(() => {
        showLoadingStep1(false);
        //
        helpers.forcedChoice();
      }, remainingTime);
    }).catch(error => {
      console.error("Erreur lors du chargement initial:", error);
      showLoadingStep1(false);
    });
  }

  // Affiche ou masque le chargement de l'étape 1
  function showLoadingStep1(show) {
    const formElements = [...dateInputs, ...radioButtons];


    if (show) {
      UIHelper.showGlobalLoading(true);
      UIHelper.setElementsDisabled(formElements, true);
    } else {
      UIHelper.showGlobalLoading(false);
      UIHelper.setElementsDisabled(formElements, false);
    }
  }

  // Met à jour l'état du bouton de soumission selon les sélections
  function updateSubmitButtonState() {
    if (submitButton) {
      const isFormValid = selectedDate && selectedRadioValue;

      if (isFormValid) {
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-disabled");
      } else {
        submitButton.setAttribute("disabled", "true");
        submitButton.setAttribute("aria-disabled", "true");;
      }
    }
  }

  // Initialise tous les écouteurs d'événements
  function initEventListeners() {
    initDateListeners();
    initRadioListeners();
    initButtonListeners();
  }

  // Initialise les écouteurs pour les champs de date
  function initDateListeners() {
    if (dateInputs.length) {
      dateInputs.forEach(input => {
        if (input.value) selectedDate = input.value;
        input.addEventListener("change", () => {
          selectedDate = input.value;
          showItemsInList(selectedDate);
          updateSubmitButtonState();
        });
      });
    } else {
      const alternativeDateInputs = document.querySelectorAll('input[type="date"], .flatpickr-input');
      alternativeDateInputs.forEach(input => {
        if (input.value) selectedDate = input.value;
        input.addEventListener("change", () => {
          selectedDate = input.value;
          showItemsInList(selectedDate);
          updateSubmitButtonState();
        });
      });
    }

    document.addEventListener("flatpickr-change", e => {
      if (e.detail && e.detail.dateStr) {
        selectedDate = e.detail.dateStr;
        showItemsInList(selectedDate);
        updateSubmitButtonState();
      }
    });
  }

  // Initialise les écouteurs pour les boutons radio
  function initRadioListeners() {
    if (radioButtons.length) {
      radioButtons.forEach(radio => {
        if (radio.checked) selectedRadioValue = radio.value;
        radio.addEventListener("change", function () {
          if (this.checked) {
            selectedRadioValue = this.value;
            updateSubmitButtonState();
          }
        });
      });
    } else {
      const alternativeRadios = document.querySelectorAll('input[type="radio"]');
      alternativeRadios.forEach(radio => {
        if (radio.checked) selectedRadioValue = radio.value;
        radio.addEventListener("change", function () {
          if (this.checked) {
            selectedRadioValue = this.value;
            updateSubmitButtonState();
          }
        });
      });
    }
  }

  // Initialise les écouteurs pour les boutons
  function initButtonListeners() {
    function handleSubmit(e) {
      e.preventDefault();
      ga4DataLayerPush(e.target);
      handleFormSubmit();
      if (e.type === "keydown") enterKeyUsed = true;
    }

    function handleRestartEvent(e) {
      e.preventDefault();
      handleRestart();
    }

    function addEventListeners(element, handler) {
      element.addEventListener("click", handler);
      element.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.keyCode === 13) {
          handler(e);
        }
      });
    }

    addEventListeners(submitButton, handleSubmit);
    addEventListeners(restartButton, handleRestartEvent);
  }

  function ga4DataLayerPush(target) {
    let clickedElemVal = target.textContent.trim().replace(/\s+/g, " ");

    let ga4Element = {
      element_label: clickedElemVal,
      step_nb: "1",
      step_name: "Type de bâtiment"
    };

    if (window.initTrackingGA4) {
      window.initTrackingGA4.sendDataToGA4(ga4Element);
    }
  }

  // Charge le fichier de listes JSON
  // DONNER LE MEME NOM DE LISTE POUR ES + date
  async function getListFile() {
    try {
      if (!window.dataLoader || typeof window.dataLoader.loadJSON !== "function") {
        return null;
      }

      fileListJson = await window.dataLoader.loadJSON(`${folderListPath}/${listName}`);

      if (!fileListJson || fileListJson.length === 0) {
        return null;
      }

      return fileListJson;

    } catch (error) {
      return null;
    }
  }

  // Détermine le fichier à sélectionner selon la date d'installation
  function determineTargetFile(installationDate) {
  console.log("Détermination du fichier cible pour la date d'installation:", installationDate);
  switch (true) {

    case installationDate >= new Date(2024, 9, 23) && installationDate <= new Date(2025, 3, 30):
      return "23-10-2024";

    case installationDate >= new Date(2025, 4, 1) && installationDate <= new Date(2025, 6, 16):
      return "01-05-2025";

    case installationDate >= new Date(2025, 6, 17) && installationDate <= new Date(2025, 10, 25):
      return "17-07-2025";

    case installationDate >= new Date(2025, 10, 26):
      return installationDate.toISOString().split("T")[0];

    default:
      return null;
  }

  }


  // Sélectionne le fichier de liste approprié en fonction de la date et du type choisis
  async function selectListFile() {
    const list = await getListFile();
    console.log('list:', list);

    if (!list) {
      return { fichier: "invalide" };
    }

    if (!selectedDate || !selectedRadioValue) {
      detectFormValues();

      if (!selectedDate || !selectedRadioValue) {
        return { fichier: "invalide"};
      }
    }

    const [year, month, day] = selectedDate.split("-").map(part => part.padStart(2, '0'));
    //const [year, month, day] = selectedDate.split("-").map(Number);
    const installationDate = new Date(year, month - 1, day);
    const installationDateISO = installationDate.toISOString().split("T")[0];

    const radioValue = selectedRadioValue;
    //console.log("Date sélectionnée:", installationDateISO, "Type sélectionné:", radioValue);

    const targetFileDate = determineTargetFile(installationDate);

   // console.log("Date cible du fichier déterminée:", targetFileDate)

    changeListOrigin(installationDate);

    try {
      const data = Array.isArray(list) ? list[0] : list;
      let categoryData = null;
      console.log("Données de la catégorie sélectionnée1:", data[radioValue]);
      // SI Neep
       if (g_listOrigin === "es") {
        categoryData = data[radioValue];
        if (!categoryData?.csves) {
         /* return {
            fichier: "invalide"
          };*/
        }
       } else {
        categoryData = data[radioValue]?.[lang];
        if (!categoryData?.csv?.length) {
          return {
            fichier: "invalide"
          };
        }
      }

      // Chercher le fichier qui contient la date cible dans son nom
      let fichierChoisi;
      if (g_listOrigin === "es") {
        // REmplace DATE par la date cible
        fichierChoisi = categoryData.csves.replace("DATE", `${year}${month}${day}`);
      } else {
       fichierChoisi = categoryData.csv.find(item => item.file.includes(targetFileDate));
      }

      console.log("Fichier choisi:", fichierChoisi);

      if (!fichierChoisi) {
        return {
          fichier: "invalide"
        };
      }

      return {
        fichier: (g_listOrigin === "es" ? fichierChoisi : fichierChoisi.file),
        affichage_date: installationDateISO,
        affichage_pdf: `${year}/${month}/${day}`,
        affichage_date_es: `${year}${month}${day}`,
        category: radioValue,
      };
    } catch (e) {
      return {
        fichier: "invalide"
      };
    }
  }

  const changeListOrigin = (date) => {

    if (date >= config.DATE_ENERGY_STAR_SWITCH) {
      setListOrigin("es");
      //Show ES radio next
      radioButttonES.forEach(radio => {
        radio.style.display = "block";
      });
      // Cache le légal
      document.querySelector('.js-texte-legal').style.display = "none";

      window.searchBy = "energystar";
      document.querySelector('.js-radio-energystar input').checked = true;
      numberTypeText.textContent = simpleSearchRadioLabels.label[lang].energystar;


    } else {
      setListOrigin("neep");
      //Hide ES radio next
       radioButttonES.forEach(radio => {
        radio.style.display = "none";
      });
      // Affiche le légal
      document.querySelector('.js-texte-legal').style.display = "block";

      window.searchBy = "ahri";

      document.querySelector('.js-radio-ahri input').checked = true;
      numberTypeText.textContent = simpleSearchRadioLabels.label[lang].ahri;
    };
  };

  // Gère la soumission du formulaire
  async function handleFormSubmit() {
    console.log("Soumission du formulaire de sélection de la liste");
    try {

      showLoadingStep1(true);
      detectFormValues();



      const selected = await selectListFile();
      window.selectListObject = selected;

      console.log("step-list-result.js : Fichier sélectionné:", selected);

      if (selected.fichier !== "invalide") {
        if (window.dataExchange.setCurrentDataset) {
          //console.log(`Changement de dataset vers le fichier sélectionné: ${selected.fichier}`);

          activeList.file = selected.fichier;
          activeList.name = selected.category;

          console.log(`Changement de dataset vers le fichier sélectionné: ${activeList.file}, catégorie: ${activeList.name}`);
          window.dataExchange.setCurrentDataset(selected.fichier);
        }
      }

      updateResultInfo(selected, selectedRadioValue);

      step1.style.display = "none";
      step2.style.display = "block";

      UIHelper.showGlobalLoading(true, lang === "en" ? "Loading search modules..." : "Chargement des modules de recherche...");

      loadStep2Data();

      scrollToStepElement(".js-stop-step-2");

      if (enterKeyUsed) {
        setTimeout(() => {
          focusRestartButton();
          enterKeyUsed = false;
        });
      }

       window.initSetupFiltres();

    } catch (error) {
      console.log("Erreur lors de la soumission du formulaire:", error);
     //showLoadingStep1(false);
     //Le loader va disparaitre automatiquement quand le daata va etre entièrement chargé
    }
  }

  // Détecte les valeurs du formulaire
  function detectFormValues() {
    if (!selectedDate) {
      const dateSelectors = [
        '.js-date-picker',
        'input[type="text"].js-date-picker',
        '.flatpickr-input',
        'input[placeholder*="date"]',
        'input[placeholder*="Date"]'
      ];

      for (const selector of dateSelectors) {
        const inputs = document.querySelectorAll(selector);
        for (const input of inputs) {
          if (input.value?.trim()) {
            selectedDate = input.value.trim();
            break;
          }

          if (input._flatpickr?.selectedDates?.length) {
            try {
              selectedDate = input._flatpickr.formatDate(input._flatpickr.selectedDates[0], "Y/m/d");
              break;
            } catch (e) { }
          }
        }
        if (selectedDate) break;
      }
    }

    if (!selectedRadioValue) {
      const radioSelectors = [
        '.js-list-radio',
        'input[type="radio"]',
        'input[name="type-question"]',
        'input[value*="proprio"]',
        'input[value*="entrepreneur"]'
      ];

      for (const selector of radioSelectors) {
        const radios = document.querySelectorAll(selector);
        for (const radio of radios) {
          if (radio.checked && radio.value) {
            selectedRadioValue = radio.value;
            break;
          }
        }
        if (selectedRadioValue) break;
      }
    }
  }

  // Met à jour les informations de résultat
  function updateResultInfo(selected) {
    const dateElement = document.querySelector(".js-result-list-date");
    const typeElement = document.querySelector(".js-result-type-batiment");
    const downloadLink = document.querySelector(".js-pdf-dowload");

    if (dateElement && selected.affichage_date) {
      dateElement.textContent = selected.affichage_date;
    }

    if (typeElement && selectedRadioValue) {
      const selectedRadio = document.querySelector(`input[value="${selectedRadioValue}"]`);
      if (selectedRadio) {
        const labelText = selectedRadio.closest("label").querySelector(".wrapper-contenu span").textContent.trim();
        const descText = selectedRadio.getAttribute("aria-describedby");
        const descElement = document.getElementById(descText);

        if (descElement) {
          const description = descElement.textContent.trim();
          typeElement.textContent = `${labelText}, ${description.toLowerCase()}`;
        }
      }
    }

// ONLY IN neep MODE
    if (downloadLink && selected.fichier && g_listOrigin !== "es") {
     downloadLink.href = `${fileListJson[1].path.pdf}${getFileName(selected.fichier, selected.category)}`;

      const weightElement = document.querySelector(".js-weight");
      if (weightElement) {
        const fileSize = getFileSize(selected.fichier, selected.category);
        weightElement.textContent = fileSize;
      }
    } else if (g_listOrigin === "es") {
      downloadLink.parentElement.style.display = "none";

    }
  }

  // Charge les données pour l'étape 2
  function loadStep2Data() {
    console.log("Chargement des données pour l'étape 2");

// Call le chargeement des données dans le module de recherche simple dansIndexeddB et indexation de la clé AHRI et EnergyStar
    if (window.initSimpleSearch?.loadSelectedData) {
      console.log("Chargement des données sélectionnées dans le module de recherche");
      window.initSimpleSearch.loadSelectedData();
    } else if (window.initSimpleSearch) {
      window.initSimpleSearch();
    }
     UIHelper.showGlobalLoading(true);
  }

    /**
   * Obtient le nom du fichier PDF correspondant au fichier CSV donné
   */
  function getFileName(filename, category) {
    if (fileListJson?.[0]?.[category]?.[lang]?.pdf) {
      const fileIndex = fileListJson[0][category][lang]["csv"].findIndex(item => item.file === filename);
      const fileName = fileIndex !== -1 ? fileListJson[0][category][lang]["pdf"][fileIndex] : null;
      if (fileName?.file) return fileName.file;
    }
    return "";
  }
  /**
   * Obtient la taille du fichier
   */
  function getFileSize(filename, category) {
    if (fileListJson?.[0]?.[category]?.[lang]?.pdf) {
      const fileIndex = fileListJson[0][category][lang]["csv"].findIndex(item => item.file === filename);
      const fileWeight = fileIndex !== -1 ? fileListJson[0][category][lang]["pdf"][fileIndex] : null;
      if (fileWeight?.height) return fileWeight.height;
    }
    return "0";
  }

  // Gère le clic sur le bouton "Modifier mes critères"
  //
  function handleRestart() {
    if (!step1 || !step2) return;
 // Recharge complètement la page en enlevant le paramètre 'liste' de l'URL
    try {
      const url = new URL(window.location.href);

      // Vérifier si le paramètre existe avant de recharger
      if (url.searchParams.has('liste')) {
        url.searchParams.delete('liste');
        window.location.href = url.toString();
      } else {
        // Si pas de paramètre 'liste', juste recharger la page
        window.location.reload();
      }
    } catch (error) {
      console.error("Erreur lors de la modification de l'URL:", error);
      // Fallback : recharger la page sans modifier l'URL
      window.location.reload();
    }
  }

  // Met le focus sur le champ de date et ouvre le date picker si demandé
  function focusDateInput(openPicker = false) {
    const visibleDateInputs = [...document.querySelectorAll(".js-date-picker:not([disabled]), .flatpickr-input:not([disabled])")].filter(el => {
      const style = window.getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden";
    });

    if (visibleDateInputs.length > 0) {
      const dateInput = visibleDateInputs[0];
      dateInput.focus();

      if (openPicker && dateInput._flatpickr) {
        setTimeout(() => {
          dateInput._flatpickr.open();
        }, 200);
      }
    }
  }

  // Réinitialise tous les filtres et sélecteurs
  function resetFiltersAndSelectors() {
    window.tableauResultats.setSelectors();
    window.initMarquesSelector.resetSelectedMarques();
  }

  // Passe de l'étape 2 à l'étape 1
  function switchToStep1() {
    step2.style.display = "none";
    step1.style.display = "block";
  }

  // Réinitialise toutes les données du formulaire
  function resetFormData() {
    selectedDate = null;
    selectedRadioValue = null;

    const allInputs = [...dateInputs, ...radioButtons];
    allInputs.forEach(input => {
      if (input.type === "radio") {
        input.checked = false;
      } else {
        input.value = "";
        input._flatpickr?.clear();
      }
    });

    updateSubmitButtonState();

    document.querySelectorAll('.js-recherche-avancee input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });

    const criteriaElements = document.querySelectorAll(".js-criterias-2");
    criteriaElements.forEach(element => {
      element.textContent = "";
    });

    try {
      const simpleSearchInstance = window.initSimpleSearch?.();
      simpleSearchInstance?.resetSearch?.();
    } catch (e) {
      console.warn("Simple search reset failed:", e.message || e);
    }

    try {
      const resultsModule = document.querySelector(".js-module-resultats-recherche");
      if (resultsModule) {
        resultsModule.innerHTML = "";
      }
    } catch (e) {
      console.warn("Simple search reset failed:", e.message || e);
    }
  }

  // Fait défiler la page jusqu'à l'élément spécifié par le sélecteur
  function scrollToStepElement(selector, openDatePicker = false) {
    setTimeout(() => {
      try {
        const targetElement = document.querySelector(selector);

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });

          if (selector === ".js-stop-step-1" && openDatePicker) {
            setTimeout(() => {
              focusDateInput(true);
            }, 500);
          }
        }
      } catch (error) {
        console.error("Erreur lors du défilement vers l'élément:", error);
      }
    }, 100);
  }

  // Met le focus sur le bouton "Modifier mes critères"
  function focusRestartButton() {
    if (restartButton) {
      setTimeout(() => {
        restartButton.focus();
      }, 500);
    }
  }

  // Enhanced data access method
  // Enhanced dataset management with validation
  const setCurrentDataset = (datasetName) => {
    console.log(`Changement de dataset vers: ${datasetName}`);
    if (!datasetName || typeof datasetName !== "string") {
      throw new Error("Nom du dataset invalide");
    }
    if (datasetName === currentDataset) {
      return false; // No change needed
    }

    // Reset state when changing datasets
    setGlobalCurrentDataset(datasetName);
    data = null;
    isLoaded = false;
    isLoading = false;
    ahriIndex = {};
    loadingPromise = null;

    return true;
  };

  //
  const showItemsInList = (date) => {
    const currentDate = new Date(date);

    let listToShow = "";
    if (currentDate < config.DATE_NEEP_FINAL) {
      listToShow = "neep";
    } else if (currentDate >= config.DATE_NEEP_FINAL && currentDate < config.DATE_ENERGY_STAR_SWITCH) {
      listToShow = "neep-transit";
    } else {
      listToShow = "es";
    }

    const listContainers = document.querySelectorAll('[data-liste]');
    listContainers.forEach(container => {
      const listes = container.getAttribute('data-liste').split(',').map(item => item.trim());
      if (listes.includes(listToShow) && container.getAttribute('data-display') !== "none") {
        container.style.display = 'block';
      } else {
        container.style.display = 'none';
      }
    });
    document.querySelector(".js-bloc-list").style.display = "block";

    // Affiche le choix seulement si la date est supérieure ou égale à la date de MEL
    const listOfficeElement = document.querySelector("#liste-office-habitation");
    if (listOfficeElement) {
      listOfficeElement.style.display = currentDate >= config.dateAffichageOH ? "block" : "none";
    }


  }

  // Exposer les méthodes publiques
 return {
    loadStep2Data,
    handleFormSubmit,
    handleRestart
  };

}

//initListPicker = initListPicker();
// Initialiser et stocker l'instance globalement
// À appeler dans votre fichier d'initialisation principal
if (typeof window !== 'undefined') {
  window.listPickerInstance = null;
}

export default initListPicker;
